module.exports = __webpack_public_path__ + "static/media/slide-3mr.58d4b696.jpg";